import React from 'react'
import { Container, LeadFormModMobPreloader } from '@rst/ui-ts'
import styled from 'styled-components'
import { media } from '@rst/libs-ts'

export const LeadFormModMob = ({ data }: any) => {
	return (
		<StyledContainer>
			<LeadFormModMobPreloader {...data} />
		</StyledContainer>
	)
}

const StyledContainer = styled(Container)<{ height?: number }>`
	display: flex;
	padding: 32px 0;
	flex-direction: column;
	align-items: center;

	${media.pure.less(575)} {
		padding: 32px 16px;
	}
`
